export default __webpack_public_path__ + "static/media/welcome.e834c659.svg";